import React from "react";

const ForwardLinkIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.655"
      height="17.147"
      viewBox="0 0 18.655 17.147"
    >
      <g id="db108" transform="translate(-224.461 -234.74)">
        <path
          id="Path_1860"
          data-name="Path 1860"
          d="M227.959,264.451h9.327a3.5,3.5,0,0,0,3.5-3.5v-3.5h-2.332v3.5a1.166,1.166,0,0,1-1.166,1.166h-9.327a1.166,1.166,0,0,1-1.166-1.166v-9.327a1.166,1.166,0,0,1,1.166-1.166h3.5v-2.332h-3.5a3.5,3.5,0,0,0-3.5,3.5v9.327a3.5,3.5,0,0,0,3.5,3.5Z"
          transform="translate(0 -12.564)"
          fill={fill ? fill : "#0051bc"}
        />
        <path
          id="Path_1861"
          data-name="Path 1861"
          d="M328.162,243.385l3.5-3.5h0a1.166,1.166,0,0,0,0-1.65l-3.5-3.5-1.65,1.65,1.507,1.507h-1.848a7,7,0,0,0-7,7v2.332h2.332v-2.332a4.663,4.663,0,0,1,4.663-4.663h1.848l-1.507,1.507Z"
          transform="translate(-88.886)"
          fill={fill ? fill : "#0051bc"}
        />
      </g>
    </svg>
  );
};

export default ForwardLinkIcon;
